import React from 'react';
import Button from '../common/Button';
import './loginStyle.css';

const SessionExistsModal = ({ onAccept, onDeny, eviewMode = false }) => {
  const modalClass = `login-modal ${eviewMode ? 'eview-mode' : ''}`;

  return (
    <div className={modalClass}>
      <p className="login-modal__title">You are already logged in.</p>
      <p className="login-modal__text">Would you like to terminate your other session?</p>
      <div className="login-modal__buttons">
        <Button onClick={onDeny} buttonText="Cancel" />
        <Button onClick={onAccept} buttonText="OK" />
      </div>
    </div>
  );
};

export default SessionExistsModal;